import { AxiosRequestConfig } from "axios";
import apiClient, { strapiApiUrl } from "../api";
import { GeoJsonExportConfig } from "@/utilities/export-helper";

interface GetGeoJSONIDInput {
    ids: number[];
    config?: GeoJsonExportConfig;
}

interface GetGeoJSONFilterInput {
    filter: any;
    config?: GeoJsonExportConfig;
}

export const getGeojsonByIds = (data: GetGeoJSONIDInput, config: AxiosRequestConfig = {}) => {
    return apiClient.post(`${strapiApiUrl}/bestandsaufnahmes/getGeojson`, {
        data
    }, config);
};

export const getGeojsonByFilter = (data: GetGeoJSONFilterInput, config: AxiosRequestConfig = {}) => {
    return apiClient.post(`${strapiApiUrl}/bestandsaufnahmes/getGeojson`, {
        data
    }, config);
};